import { LayerProps } from "react-map-gl/maplibre";
import { BubbleConfigs } from "~map-style-utils/types/__generated/gql/graphql";

export const getBubbleStyle = (
	configs: BubbleConfigs,
	datasetId: string,
): LayerProps[] => {
	const { symbolStyle, valueField, symbolValues, radius } = configs;

	const styles: LayerProps[] = [];

	styles.push({
		id: "bubble",
		type: "circle",
		source: datasetId,
		paint: {
			// @ts-ignore
			"circle-radius": [
				"step",
				["get", valueField!],
				...symbolValues!.flatMap(({ symbol, min }) => [
					symbol!.basic!.size!,
					min!,
				]),
				radius!.max!,
			],
			"circle-color": symbolStyle?.fill?.color ?? "#ffffff",
			"circle-opacity": symbolStyle?.fill?.opacity ?? 1,
			"circle-stroke-color": symbolStyle?.stroke?.color ?? "#000000",
			"circle-stroke-width": symbolStyle?.stroke?.width ?? 1,
			"circle-stroke-opacity": symbolStyle?.stroke?.opacity ?? 1,
		},
	});

	return styles;
};
